export default function TicketIcon({ size = 16, ...props }) {
    return (
        <img
            src="/assets/icons/ticket-badge.svg"
            alt="Ticket"
            style={{ width: size, height: size }}
            {...props}
        />
    );
}
